export default {
  available: 'Verfügbar',
  selected: 'Ausgewählt',
  noItemsSelected: 'Keine Zeilen ausgewählt',
  confirm: 'Bist du sicher?',
  fields: {
    action: 'Action',
    name: 'Name',
    added: 'Hinzugefügt',
  },
  status: {
    title: 'Status',
    added: 'Hinzugefügt',
    noAdded: 'Nicht hinzugefügt',
  },
  search: 'Suche',
  noMatchingResults: 'Keine passenden Zeilen gefunden',
  noDataAvailable: 'Keine Daten vorhanden',
  rowsPerPageText: 'Zeilen pro Seite:',
  records: 'Datensätze',
  from: 'von',
  add: 'Hinzufügen',
  all: 'Alle',
  buttons: {
    remove: 'Löschen',
    add: 'Hinzufügen',
    removeMany: 'Auswahl löschen',
    addMany: 'Auswahl hinzufügen',
    close: 'Schließen',
  },
}
